/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rusarabuye 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kabona": ["Bucyaba", "Busutamo", "Buzamuye", "Gahinga", "Gasongati", "Gikore", "Karambo", "Muharuro", "Munanira", "Murambo", "Musebeya", "Ntagara", "Rutuku"],
  "Ndago": ["Burehe", "Gacaca", "Gaseke", "Gitovu", "Kajerijeri", "Karorero", "Kirambo", "Ndago", "Nyarungu"],
  "Ruhanga": ["Bisayu I", "Bisayu II", "Bumba", "Kamukondo", "Kanigo", "Karuhanga", "Kibuye", "Ngundu", "Ruhanga", "Ruhurura I", "Ruhurura II", "Rutoro"]
};